import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { Smartphone } from "lucide-react";
import { useAirtimeLink } from "@/constants/links";

export function Navbar() {
  const { user } = useAuth();
  const airtime = useAirtimeLink();
  const home = user && user.role === "admin" ? "/admin" : "/dashboard";
  return (
    <header className="fixed inset-x-0 top-0 z-50 glass border-b border-brand-line/70" data-testid="navbar">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-8">
        <Link to="/" data-testid="nav-logo-link"><Logo /></Link>
        <nav className="hidden items-center gap-8 text-sm font-medium text-brand-slate md:flex">
          <a href="#how" className="transition-colors hover:text-brand-blue" data-testid="nav-how-link">How it works</a>
          <a href="#services" className="transition-colors hover:text-brand-blue" data-testid="nav-services-link">Services</a>
          <a href="#caregivers" className="transition-colors hover:text-brand-blue" data-testid="nav-caregivers-link">For caregivers</a>
          {airtime && (
            <a href={airtime} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 rounded-full border border-brand-emerald/40 px-3 py-1 text-brand-emerald transition-colors hover:bg-brand-emerald/10" data-testid="nav-airtime-link">
              <Smartphone className="h-3.5 w-3.5" /> Bhasa Airtime
            </a>
          )}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <Link to={home} className="rounded-full bg-brand-blue px-5 py-2 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-brand-blueHover" data-testid="nav-dashboard-link">
              {user.role === "admin" ? "Admin portal" : "My dashboard"}
            </Link>
          ) : (
            <>
              <Link to="/login" className="hidden text-sm font-semibold text-brand-navy transition-colors hover:text-brand-blue sm:block" data-testid="nav-login-link">Log in</Link>
              <a href="#waitlist" className="rounded-full bg-brand-gold px-5 py-2 text-sm font-semibold text-brand-navy shadow-gold transition hover:-translate-y-0.5 hover:brightness-105" data-testid="nav-waitlist-link">Join waitlist</a>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
